import { Link } from "react-router-dom";
import { useI18n } from "@/i18n";
import { COMPANY } from "@/content/company";
import { Wordmark } from "./Logo";
import { LangSwitch } from "./Header";

export const LEGAL_DOCS = ["imprint", "privacy", "cookies", "accessibility", "terms"];

export const Footer = () => {
  const { t } = useI18n();
  return (
    <footer data-testid="site-footer" className="overflow-hidden border-t border-white/10 pb-10 pt-20">
      <div className="wrap grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Wordmark />
          <p className="mt-6 max-w-xs font-display text-2xl tracking-tight text-zinc-300">{t.footer.tagline}</p>
          <LangSwitch prefix="footer-lang" className="mt-8 w-fit" />
        </div>
        <div className="lg:col-span-4">
          <p className="eyebrow">{t.footer.company}</p>
          <address data-testid="footer-company" className="mt-5 space-y-1.5 text-sm not-italic leading-relaxed text-zinc-300">
            <span className="block text-bone">{COMPANY.name}</span>
            <span className="block">{COMPANY.address}</span>
            <span className="block">{t.contact.details.registry}: {COMPANY.registryCode}</span>
            <span className="block">VAT: {COMPANY.vat}</span>
            <span className="block">{COMPANY.email}</span>
            <span className="block">{COMPANY.phone}</span>
          </address>
        </div>
        <nav className="lg:col-span-3" aria-label={t.footer.legal}>
          <p className="eyebrow">{t.footer.legal}</p>
          <ul className="mt-5 space-y-2.5 text-sm">
            {LEGAL_DOCS.map((d) => (
              <li key={d}><Link to={`/legal/${d}`} data-testid={`footer-legal-${d}`} className="nav-link text-zinc-300 hover:text-bone">{t.legalNav[d]}</Link></li>
            ))}
            <li className="pt-3"><Link to="/admin" data-testid="footer-admin-link" className="nav-link text-zinc-400 hover:text-bone">{t.footer.admin}</Link></li>
          </ul>
        </nav>
      </div>
      <div aria-hidden className="stroke-text mt-20 select-none whitespace-nowrap text-center font-display text-[23vw] font-semibold leading-[0.8] tracking-[-0.06em]">GridJob</div>
      <div className="wrap mt-10 flex flex-col gap-2 border-t border-white/10 pt-6 font-mono text-xs text-zinc-400 sm:flex-row sm:justify-between">
        <span>© {new Date().getFullYear()} {COMPANY.name}. {t.footer.rights}</span>
        <span>{t.footer.photos}</span>
      </div>
    </footer>
  );
};
